var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333,8.657C4.28,8.76 4.25,8.876 4.25,9L4.25,18C4.25,19.508 5.492,20.75 7,20.75L9,20.75C9,20.75 9.001,20.75 9.001,20.75C9.334,20.75 9.616,20.532 9.713,20.232L9.719,20.213L9.725,20.194L9.731,20.169L9.737,20.142L9.741,20.114L9.745,20.086L9.748,20.058L9.749,20.029L9.75,20L9.75,16C9.75,15.314 10.314,14.75 11,14.75C11,14.75 13,14.75 13,14.75C13.686,14.75 14.25,15.314 14.25,16L14.25,20L14.25,20.022L14.251,20.041L14.252,20.059L14.254,20.077C14.269,20.228 14.33,20.366 14.421,20.477L14.433,20.491L14.445,20.504L14.458,20.518L14.47,20.531L14.483,20.543L14.496,20.556L14.51,20.568L14.524,20.579L14.538,20.591L14.553,20.602L14.567,20.612L14.582,20.623L14.598,20.633L14.621,20.647L14.645,20.661L14.669,20.673L14.694,20.685L14.72,20.696L14.742,20.704L14.768,20.713L14.795,20.722L14.822,20.729L14.849,20.735L14.877,20.74L14.905,20.744L14.933,20.747L14.961,20.749L14.99,20.75L15,20.75L17,20.75C18.508,20.75 19.75,19.508 19.75,18L19.75,9C19.75,8.876 19.72,8.76 19.667,8.657C19.614,8.554 19.537,8.462 19.436,8.39L12.436,3.39C12.175,3.203 11.825,3.203 11.564,3.39L4.564,8.39C4.463,8.462 4.386,8.554 4.333,8.657ZM5.75,9.386L5.75,18C5.75,18.686 6.314,19.25 7,19.25L8.25,19.25L8.25,16C8.25,14.492 9.492,13.25 11,13.25L13,13.25C14.508,13.25 15.75,14.492 15.75,16L15.75,19.25L17,19.25C17.686,19.25 18.25,18.686 18.25,18L18.25,9.386L12,4.922L5.75,9.386Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.efa68ec5.svg";
export { ForwardRef as ReactComponent };